module.exports = "<toaster-container></toaster-container>\n<ng2-app></ng2-app>\n"